<template>
<div class="pieReport">
    <div class="myChart" :id="data.id"></div>
</div>
</template>

<script>
import echarts from 'echarts'
export default {
    name: 'pieReport',
    data() {
        return {
            datas: []
        }
    },
    props: ['data'],
    mounted() {
        this.drawLine()
    },
    methods: {
        drawLine() {
            this.datas = this.data.list
            let legend = []
            for (var i = 0; i < this.datas.length; i++) {
                legend[i] = this.datas[i].name
            }
            // 基于准备好的dom，初始化echarts实例
            let myChart = echarts.init(document.getElementById(this.data.id))
            // 绘制图表
            myChart.setOption({
                title: {
                    text: this.data.title,
                    subtext: this.data.subText,
                    x: 'center',
                    textStyle: {
                        fontSize: 16
                    }
                },
                color: this.data.color,
                tooltip: {
                    trigger: 'item',
                    // position: ['20%', '45%'],
                    formatter: '{a} {b} : {c} ({d}%)'
                },
                legend: {
                    orient: 'vertical',
                    left: 'left',
                    top: '20px',
                    data: legend,
                    formatter: function (name) {
                        var len = this.datas.length
                        for (var i = 0; i < len; i++) {
                            if (this.datas[i].name === name) {
                                return name + ':' + this.datas[i].value + '人'
                            }
                        }
                    }.bind(this)
                },
                series: [
                    {
                        name: '',
                        type: 'pie',
                        radius: '50%',
                        center: ['52%', '40%'],
                        data: this.datas,
                        itemStyle: {
                            normal: {
                                // color: '#c23531',
                                // shadowBlur: 200,
                                // shadowColor: 'rgba(0, 0, 0, 0.5)'
                            },
                            emphasis: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            })
        }
    },
    watch: {
        data: {
            handler: function () {
                this.drawLine()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.pieReport {
    .myChart {
        width: 100%;
        height: 300px;
    }
}
</style>
